import { Staff } from "../models/staff";

export const getStaffDescription = (staff?: Staff) => {
  const name = staff?.firstName || "";
  const lastName = staff?.lastName || "";
  const email = staff?.email || "";

  return `${name} ${lastName} ${email ? `- ${email}` : ""}`;
};
